import { useState } from 'react';
import { Crosshair } from 'lucide-react';
import { normalizeRotation, metrics } from './editorCatalog';
import { areaOf } from './model';
import { PropertyRange } from './PropertyControls';
import { DimensionFields } from './TextFormatSheets';
import { stretchable } from './stretchDrag';

const fmt = v => (Math.round(v * 10) / 10).toString().replace('.', ',');

const NumField = ({ id, label, value, unit, disabled, onCommit, min = -Infinity }) => {
  const [draft, setDraft] = useState(null);
  const commit = () => { if (draft === null) return; const v = parseFloat(draft.replace(',', '.')); if (Number.isFinite(v) && v >= min) onCommit(v); setDraft(null); };
  return <label className="cm-field"><span>{label}</span><input type="text" inputMode="decimal" value={draft ?? fmt(value)} disabled={disabled} onFocus={e => e.target.select()} onChange={e => setDraft(e.target.value)} onBlur={commit} onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); e.stopPropagation(); }} data-testid={`${id}-input`} /><em>{unit}</em></label>;
};

// Exact placement: element centre in mm from the top-left corner of the design area, rotation in degrees, size via the cm fields.
export const PositionSheet = ({ editor, o }) => {
  const a = areaOf(editor.product), k = metrics.unitsPerMm, x = (o.x - a.x) / k, y = (o.y - a.y) / k;
  return <div className="position-sheet" data-testid="sheet-position">
    <div className="pos-fields">
      <NumField id="pos-x" label="X" value={x} unit="mm" disabled={o.locked} onCommit={v => editor.patchObject(o.id, { x: a.x + v * k })} />
      <NumField id="pos-y" label="Y" value={y} unit="mm" disabled={o.locked} onCommit={v => editor.patchObject(o.id, { y: a.y + v * k })} />
      <NumField id="pos-rotation" label="Drehung" value={normalizeRotation(o.rotation || 0)} unit="°" disabled={o.locked} onCommit={v => editor.patchObject(o.id, { rotation: normalizeRotation(v) })} />
    </div>
    <small className="sheet-hint" data-testid="position-hint">Mitte des Elements, gemessen von der linken oberen Ecke der Gestaltungsfläche ({fmt(a.w / k)} × {fmt(a.h / k)} mm).</small>
    <button type="button" className="mask-toggle" disabled={o.locked} onClick={() => editor.patchObject(o.id, { x: a.cx, y: a.cy })} data-testid="pos-center"><Crosshair size={14} />Mittig auf die Fläche setzen</button>
    {stretchable(o) && <DimensionFields editor={editor} o={o} />}
  </div>;
};

// Textile only: opacity is stored as `lightness` (0 = solid … 80 = 20 % opacity), the same value the print renderer uses.
export const OpacitySheet = ({ editor, o }) => <div data-testid="sheet-opacity">
  <PropertyRange editor={editor} id="opacity" label="Deckkraft" value={100 - (o.lightness || 0)} min={20} max={100} buttonStep={5} unit=" %" onChange={(v, record) => editor.patchObject(o.id, { lightness: Math.round(100 - v) }, record)} />
  <small className="sheet-hint" data-testid="opacity-hint">100 % = voll deckend · niedriger lässt die Shirtfarbe durchscheinen</small>
</div>;
